// Giriş/şifre/aktivasyon ekranlarında 429 mesajı — TEK kaynak (Login via auth-store, Forgot,
// FirstLogin). Backend auth/rate-limit.ts Türkçe gövde döner:
//   { error: "rate_limited", message: "Çok fazla deneme. Lütfen N dakika sonra tekrar deneyin.", retryAfterSeconds }
// Gövde gelmezse (ör. ters vekil 429'u, JSON değil) sabit Türkçe yedek — hardcoded İngilizce
// "Rate limit exceeded" ya da "HTTP 429" asla ekrana çıkmaz.

import { ApiError } from "../api/client";

export const RATE_LIMIT_FALLBACK_MESSAGE = "Çok fazla deneme. Lütfen biraz sonra tekrar deneyin.";

/** 429 ise gösterilecek Türkçe mesaj; değilse null (çağıran kendi dalına düşer). */
export function rateLimitMessage(err: unknown): string | null {
  if (!(err instanceof ApiError) || err.status !== 429) return null;
  if (err.code === "rate_limited" && err.message.trim().length > 0) return err.message;
  return RATE_LIMIT_FALLBACK_MESSAGE;
}
